import { Pipe, PipeTransform } from '@angular/core';

import { DataState } from '../model/data-state';
import { injectSchemaResolver } from './schema-resolver';

/**
 * A text a component shows, with every `$$root.key$$` filled through the one resolver (README-TECH §13). It runs after
 * `translate` where the text is translated, so a placeholder may sit in the translation value. `$data` and `$state` are
 * the component's own state, handed over as the argument; `$context` and `$source` are read at the component's place.
 *
 * Impure: a context or a source is a signal the resolver reads while the template runs, and a pure pipe would hand back
 * the text it cached when only that signal changed. A text with no `$` comes back as it is, without asking the resolver.
 */
@Pipe({ name: 'schemaText', pure: false })
export class SchemaTextPipe implements PipeTransform {
  readonly #schema = injectSchemaResolver();

  transform(text: string | null | undefined, state: DataState | undefined): string {
    if (!text) {
      return '';
    }

    return text.includes('$') ? String(this.#schema.resolve(text, state) ?? '') : text;
  }
}
